import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Sidebar } from 'primereact/sidebar';
import { TieredMenu } from 'primereact/tieredmenu';
import { Card } from 'primereact/card';

// Column
import { UserManagementListColumns } from '../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate } from '../../appconfig/Settings';

//Services
import { deleteData, getAllDetails, postAllData } from '../../service/ProductService';

import { Buffer } from 'buffer';
import { CREATE_USER, ROLE_LIST, USERLIST, DELETE_USER } from '../../config/ApiConstant';
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { addUpdateUserValidate } from '../../config/Validate';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';
import { Timeline } from 'primereact/timeline';
// import avatar from "../../../public/assets/images/avatar.png"

export const UserHistory = () => {
    document.title = 'User Management | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [roleDropdown, setRoleDropdown] = useState<any>([]);
    const [userList, setUserList] = useState<any>([]);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [userDetails, setUserDetails] = useState<any>({});
    const [editId, setEditId] = useState<any>(null);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});

    // useEffect
    useEffect(() => {
        getUserList();
        getRoles();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get all roles for dropdown
    const getRoles = async () => {
        try {
            const response = await getAllDetails(ROLE_LIST);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setRoleDropdown([]);
                } else {
                    let roleData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const roleObj: any = {};
                        if (DataList[i].name !== 'User') {
                            roleObj['name'] = DataList[i].name;
                            roleObj['code'] = DataList[i].id;
                            roleData.push(roleObj);
                        }
                    }
                    setRoleDropdown(roleData);
                }
            } else {
                setRoleDropdown([]);
            }
        } catch (error: any) {
            setRoleDropdown([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get user list api call
    const getUserList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(USERLIST);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setUserList([]);
                } else {
                    setUserList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setUserList([]);
            }
        } catch (error: any) {
            if (error.response) {
                setPageLoad(false);
                setUserList([]);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <Button label="Add User" icon="pi pi-plus" className="p-button mr-2" onClick={() => openAddModal()} />
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name == 'role') {
            val = e;
        } else {
            val = (e.target && e.target.value) || '';
        }
        setUserDetails({ ...userDetails, [name]: val });
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        setEditId(rowData.id);
        setUserDetails({
            role: { name: rowData.user_type, code: rowData.role },
            first_name: rowData.full_name.split(' ')[0],
            sur_name: rowData.full_name.split(' ')[1],
            email: rowData.email,
            mobile: rowData.mobile
        });
        setAddUpdateModal(true);
    };

    // Close add update modal
    const closeAddUpdateModal = () => {
        setEditId(null);
        setUserDetails({});
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
    };

    // On submit add edit
    const onSubmitAddEdit = async () => {
        try {
            const { errors, isError } = addUpdateUserValidate(userDetails, editId);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                //Request object
                let formData: any = new FormData();

                // Check editing is performed or not
                if (editId !== null) {
                    formData.append('id', editId);
                } else {
                    formData.append('email', userDetails.email);
                    let Bufpassword = Buffer.from(userDetails.password).toString('base64');
                    formData.append('password', Bufpassword);
                }

                formData.append('user_type', userDetails.role.name);
                formData.append('role', userDetails.role.code);
                formData.append('full_name', userDetails.first_name + ' ' + userDetails.sur_name);
                formData.append('mobile', userDetails.mobile);

                //apicall
                const response = await postAllData(CREATE_USER, formData);
                if (response && !window.cn(response)) {
                    setUserDetails({});
                    setEditId(null);
                    setAddUpdateLoader(false);
                    setAddUpdateModal(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        getUserList();
                    }, 1500);
                }
            }
        } catch (error: any) {
            if (error.response) {
                const backendErrors = error.response.data.errors;

                if (backendErrors) {
                    // Map backend errors to your state
                    const formattedErrors: any = {};

                    Object.keys(backendErrors).forEach((key) => {
                        formattedErrors[key] = backendErrors[key].join(' '); // Convert array messages into a single string
                    });
                    setErrors(formattedErrors);
                    setAddUpdateLoader(false);

                    toast.current?.show({
                        severity: 'error',
                        summary: 'Validation Error',
                        detail: 'Please fix the errors and try again.'
                    });
                } else {
                    //Spinner False and Set Toast

                    setAddUpdateLoader(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
                }
            }
        }
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteLoader(false);
        setDeleteModal(false);
    };

    // On submit delete
    const onSubmitDelete = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteData(DELETE_USER, deleteId);
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                getUserList();
                setPageLoad(true);
            } else {
                setPageLoad(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="Edit" tooltipOptions={{ position: 'top' }} icon="pi pi-pencil" onClick={() => openEditModal(rowData)} />
                    <Button tooltip="Delete" tooltipOptions={{ position: 'top' }} icon="pi pi-trash" onClick={() => openDeleteModal(rowData.id)} className="p-button-danger ml-2" />
                </div>
            </>
        );
    };

    const [selectedCity, setSelectedCity] = useState(null);

    const [visibleRight, setVisibleRight] = useState(false);
    const sidebarStyles = {
        sidebar: {
            width: 300
        }
    };

    const actionsTemplateView = (rowData: any, rowIndex: any) => {
        return (
            <>
                {/* <div className="actions action-btn">
                    <div className="flex gap-2 justify-content-center">
                        <Button tooltip="View" label="View 360°" onClick={() => setVisibleRight(true)} />
                    </div>
                    <Sidebar className="user_sidebar" baseZIndex={1000000} visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
                        <div className="user_history">
                            <h2 className="mb-5">User History</h2>
                            <div className="fresh_app">
                                <h3>Fresh Application</h3>
                                <h6 className="year">2025</h6>
                                <span className="year">Approve Due</span>
                                <p className="approve">
                                    <b>Approve By :- </b>
                                    <span className="name">Author Name</span>
                                </p>
                                <div className="documents">
                                    <div className="document-hover-container">
                                        <Button icon="pi pi-file" className="p-button-text p-button-plain document-hover-trigger" aria-label="Documents" />
                                        <div>
                                            <Button className="p-button-text p-button-plain document-hover-trigger" aria-label="Documents">
                                                <h5>Documents</h5>
                                            </Button>
                                        </div>
                                        <div className="document-hover-list">
                                            <ul>
                                                <li>
                                                    <i className="pi pi-file-pdf"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document1.pdf
                                                    </a>{' '}
                                                </li>
                                                <li>
                                                    <i className="pi pi-file-excel"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document2.pdf
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className="pi pi-file-word"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document3.pdf
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="fresh_app">
                                <h3>Renew Application</h3>
                                <h6 className="year">2025</h6>
                                <span className="year">Approve Due</span>
                                <p className="approve">
                                    <b>Approve By :- </b>
                                    <span className="name">Author Name</span>
                                </p>

                                <div className="documents">
                                    <div className="document-hover-container">
                                        <Button icon="pi pi-file" className="p-button-text p-button-plain document-hover-trigger" aria-label="Documents" />
                                        <div>
                                            <Button className="p-button-text p-button-plain document-hover-trigger" aria-label="Documents">
                                                <h5>Documents</h5>
                                            </Button>
                                        </div>
                                        <div className="document-hover-list">
                                            <ul>
                                                <li>
                                                    <i className="pi pi-file-pdf"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document1.pdf
                                                    </a>{' '}
                                                </li>
                                                <li>
                                                    <i className="pi pi-file-excel"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document2.pdf
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className="pi pi-file-word"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document3.pdf
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Sidebar>
                </div> */}

                <div className="actions action-btn">
                    <div className="flex gap-2  justify-content-center">
                        <Button tooltip="View" label="View 360°" onClick={() => setVisibleRight(true)} />
                    </div>
                </div>
            </>
        );
    };

    const nameTemplate = (rowData: any) => {
        return <>{rowData.full_name}</>;
    };

    // ...............
    const timelineData = [
        {
            id: 1,
            title: 'Fresh Application',
            applied_date: 'Jan 10, 2023',
            approve_date: 'Jan 20, 2023',
            name: 'Mrs. Dhrupal Patel',
            status: 'Success'
        },
        {
            id: 2,
            title: 'Renew Application',
            applied_date: 'Jan 10, 2023',
            approve_date: 'Jan 20, 2023',
            name: 'Mrs. Dhrupal Patel',
            status: 'Pending'
        }
    ];
    const items = [
        {
            label: 'Documents'
        },
        {
            label: 'Documents 2'
        },
        {
            label: 'Documents 3'
        },
        {
            label: 'Documents 4'
        }
    ];

    const events = [
        { status: 'Success', title: 'Fresh Application', date: '15/10/2020 10:30', icon: 'pi pi-shopping-cart', color: '#9C27B0', image: 'game-controller.jpg' },
        { status: 'Pending', title: 'Renew Application', date: '15/10/2020 14:00', icon: 'pi pi-cog', color: '#673AB7' },
        { status: 'Rejected', title: 'Name Change Application', date: '15/10/2020 16:15', icon: 'pi pi-shopping-cart', color: '#FF9800' },
        { status: 'Success', title: 'Good Standing Application', date: '16/10/2020 10:00', icon: 'pi pi-check', color: '#607D8B' },
        { status: 'Success', title: 'Address Change Application', date: '16/10/2020 10:00', icon: 'pi pi-check', color: '#607D8B' }
    ];

    const customizedMarker = (_items: any, index: any) => {
        const isLast = index === events.length - 1;
        return (
            <span className={`custom-marker flex align-items-center justify-content-center text-white border-circle shadow-1 ${isLast ? 'last-marker' : ''}`} style={{ backgroundColor: 'blueviolet', height: '20px', width: '20px' }}>
                <i></i>
            </span>
        );
    };

    const customizedContent = (_items: any) => {
        return (
            <div style={{ backgroundColor: '#ECECF9', width: '100%' }}>
                <div className="user_slider">
                    <div className="user_history">
                        <div className="fresh_app">
                            <div className="">
                                <div className="heading_div">
                                    <h3 className="heading">{_items.title}</h3>
                                    <p className="status_h">
                                        {' '}
                                        Status:- <Badge value={_items.status} severity={_items.status === 'Success' ? 'success' : _items.status === 'Rejected' ? 'danger' : 'warning'}></Badge>
                                    </p>
                                </div>
                                <div className="date_h">
                                    <h6 className="year">Applied On:- Jan 01, 2025</h6>
                                    <h6 className="statuses">Approved On:- Jan 01, 2025</h6>
                                </div>
                                <span className="year">Approve Due:- Mar 05, 2025</span>
                                <div className="author-area">
                                    <div className="author-img">
                                        <Avatar image="/assets/images/avatar.png" size="xlarge" shape="circle" />
                                    </div>
                                    <div className="author-name-desig">
                                        <span>Approve By :- </span>
                                        <h6 className="">Mrs. Dhrupal Patel</h6>
                                    </div>
                                </div>
                                <div className="documents">
                                    <div className="document-hover-container">
                                        <div>
                                            <Button className="p-button-text p-button-plain document-hover-trigger" aria-label="Documents">
                                                <p>Documents</p>
                                            </Button>
                                        </div>
                                        <div className="document-hover-list">
                                            <ul>
                                                <li>
                                                    <i className="pi pi-file-pdf"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document1.pdf
                                                    </a>{' '}
                                                </li>
                                                <li>
                                                    <i className="pi pi-file-excel"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document2.pdf
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className="pi pi-file-word"></i>
                                                    <a href="https://www.google.com/" target="">
                                                        Document3.pdf
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'User History'} pageName={'User History'} pageTitle={'User History'} />
            <div className="grid crud-demo">
                <div className="col-12 ">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={userList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={userList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Users Found"
                                >
                                    {UserManagementListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplateView} />;
                                        } else if (col.field === 'mobile') {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        } else if (col.field === 'user_type') {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        } else if (col.field === 'name') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={nameTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {UserManagementListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>

                                {/* ........................ view button start................................  */}

                                {/* <div className="actions action-btn">
                                    <div className="flex gap-2  justify-content-center">
                                        <Button tooltip="View" label="View 360°" onClick={() => setVisibleRight(true)} />
                                    </div>
                                    <Sidebar className="user_sidebar" baseZIndex={1000000} visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
                                        <div className="user_history">
                                            <h2 className="mb-5">Author Name</h2>
                                            <Card className="history_content card_animation" style={{ backgroundColor: 'ECECF9' }}>
                                                <Timeline value={events} className="customized-timeline timeline_chage" marker={(_items, index) => customizedMarker(_items, index)} content={customizedContent} />
                                            </Card>
                                        </div>
                                    </Sidebar>
                                </div> */}
                                {/* .................................... view button end .............................. */}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Sidebar className="user_sidebar" baseZIndex={1000000} visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
                <div className="user_history">
                    <h2 className="mb-5">Author Name</h2>
                    <Card className="history_content card_animation" style={{ backgroundColor: 'ECECF9' }}>
                        <Timeline value={events} className="customized-timeline timeline_chage" marker={(_items, index) => customizedMarker(_items, index)} content={customizedContent} />
                    </Card>
                </div>
            </Sidebar>
        </>
    );
};
